import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import buildupLogo from "../assets/images/bild-loader1.png"; // your logo path

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden"; // prevent scroll

    const resources = [...document.images, ...document.querySelectorAll("video")];
    const totalResources = resources.length || 1; // avoid division by zero

    let loadedResources = 0;

    const updateProgress = () => {
      loadedResources += 1;
      setProgress(Math.round((loadedResources / totalResources) * 100));

      if (loadedResources >= totalResources) {
        setTimeout(() => {
          setIsLoaded(true);
          document.body.style.overflow = ""; // re-enable scroll
        }, 2000); // slight delay for smoother exit
      }
    };

    if (resources.length === 0) {
      updateProgress();
    } else {
      resources.forEach((res) => {
        if ((res.tagName === "IMG" && res.complete) || (res.tagName === "VIDEO" && res.readyState >= 3)) {
          updateProgress();
        } else {
          const eventType = res.tagName === "IMG" ? "load" : "loadeddata";
          res.addEventListener(eventType, updateProgress);
          res.addEventListener("error", updateProgress);
        }
      });
    }

    return () => {
      document.body.style.overflow = ""; // cleanup
    };
  }, []);

  return (
    <AnimatePresence>
      {!isLoaded && (
        <motion.div
          className="fixed inset-0 bg-[#161d22] flex flex-col h-screen justify-center items-center z-[9999]"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.8 } }}
        >
          <motion.img
            src={buildupLogo}
            alt="Buildup Logo"
            className="w-[65vh] h-[25vh] mb-0"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ scale: 1.5, opacity: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          />

          <div className="w-[45vh] h-2 bg-gray-500 overflow-hidden rounded-full mx-auto">
            <motion.div
              className="h-full bg-gradient-to-r from-white via-gray-300 to-white bg-[length:200%_100%] animate-shimmer rounded-full"
              style={{ width: `${progress}%` }}
              transition={{ ease: "easeOut", duration: 0.5 }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
